import DateFilter from './DateFilter';
import DataFilter from './DataFilter';

export {
  DateFilter,
  DataFilter,
};



// WEBPACK FOOTER //
// ./src/components/Filters/index.js